import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@dashboard/context/AuthContext/AuthContext';
import { fetcher } from '@dashboard/services/request';
import { pageKey } from '@dashboard/lib/queryKeys';

export const useUpdateFunnelStep = checkoutId => {
  const queryClient = useQueryClient();
  const { sellerId, token } = useAuth();

  return useMutation({
    mutationFn: ({ funnelStepId, updates }) => {
      return fetcher(`/sellers/${sellerId}/pages/${checkoutId}/funnel/${funnelStepId}`, token, {
        method: 'POST',
        body: JSON.stringify(updates),
      });
    },
    onSuccess: () => queryClient.invalidateQueries({ queryKey: pageKey(checkoutId) }),
  });
};

export const useAddFunnelStep = checkoutId => {
  const queryClient = useQueryClient();
  const { sellerId, token } = useAuth();

  return useMutation({
    mutationFn: ({ updates }) =>
      fetcher(`/sellers/${sellerId}/pages/${checkoutId}/funnel`, token, {
        method: 'POST',
        body: JSON.stringify(updates),
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: pageKey(checkoutId) }),
  });
};

export const useDeleteFunnelStep = checkoutId => {
  const queryClient = useQueryClient();
  const { sellerId, token } = useAuth();

  return useMutation({
    mutationFn: funnelStepId =>
      fetcher(`/sellers/${sellerId}/pages/${checkoutId}/funnel/${funnelStepId}`, token, {
        method: 'DELETE',
      }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: pageKey(checkoutId) }),
  });
};
